export const Identification = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="4" cy="4" r="3" transform="matrix(-1 0 0 1 16 9)" stroke="currentColor" stroke-width="2"/>
<path d="M7 23V21C7 19.8954 7.89543 19 9 19H15C16.1046 19 17 19.8954 17 21V23" stroke="currentColor" stroke-width="2"/>
<path d="M26 11H19" stroke="currentColor" stroke-width="2"/>
<path d="M26 15H22" stroke="currentColor" stroke-width="2"/>
<rect x="-1" y="1" width="26" height="22" rx="1" transform="matrix(-1 0 0 1 28 4)" stroke="currentColor" stroke-width="2"/>
</svg>`;
